<template>
  <div class="modal_documentation" :class="{h100 : this_page}">

    <span
        v-if="this_page"
        class="download_btn btn btn-success btn-fill btn-wd marginButton"
        @click.prevent="download"
    >
      {{ translate('btn.download') }}
    </span>

    <VueMarkdown
        v-if="documentation !== ''"
        class="documentation"
        :class="{h100 : this_page}"
    >
      {{ documentation }}
    </VueMarkdown>

    <div class="text-center" v-if="!this_page">

      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('btn.close') }}
      </span>

      <span
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="download"
      >
        {{ translate('btn.download') }}
      </span>

    </div>
  </div>

</template>
<script>

import VueMarkdown from 'vue-markdown'

export default {
  components:{
    VueMarkdown
  },

  data () {
    return {
      documentation: ''
    }
  },

  created() {
    this.init()
  },

  activated() {
    if (this.documentation !== '') this.init()
  },

  computed:{
    this_page(){
      return this.$route.name === "documentation"
    }
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    download () {
      let blob = new Blob([this.documentation])
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Documentation.txt'
      link.click()
    },
    init(){
      this.$http.v1.getConfigDocumentation( (response) => {
        this.documentation = response.data.documentation
      })
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_documentation{
    padding: 10px;
    position: relative;
    & > .download_btn{
      position: absolute;
      top: 40px;
      right: 30px;
    }
  }
  .documentation{
    max-height: 700px;
    overflow-y: scroll;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }

  .h100{
    height: 100%;
    max-height: none;
  }
</style>
